var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3C8.55229 3 9 3.44772 9 4V7.58579L11.5355 10.1213C11.9261 10.5118 11.9261 11.145 11.5355 11.5355C11.145 11.9261 10.5118 11.9261 10.1213 11.5355L7.29289 8.70711C7.10536 8.51957 7 8.26522 7 8V4C7 3.44772 7.44772 3 8 3Z",
    fill: "currentColor"
  })));
}

export default SvgTime;